/** iter 42 — Mobile / Route detail with stops + per-stop "+ Add Attempt". */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../lib/api";
import MobileShell from "../MobileShell";

export default function MRouteDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [route, setRoute] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/mobile/routes/${id}`)
      .then(r => setRoute(r.data))
      .catch(e => setErr(e?.response?.data?.detail || e.message));
  }, [id]);

  return (
    <MobileShell title={route?.name || "Route"} back="/m/routes">
      {err && <div className="m-empty">{String(err)}</div>}
      {!err && !route && <div className="m-empty">Loading…</div>}
      {route && (
        <>
          <div className="m-card">
            <div className="m-card-title">{route.name || "Untitled route"}</div>
            <div className="m-card-sub">
              {route.scheduled_date || ""}
              {route.start_time && ` · ${new Date(route.start_time).toLocaleTimeString()}`}
            </div>
            {route.notes && <div style={{ marginTop: 6 }}>{route.notes}</div>}
          </div>

          {route.stops?.length === 0 && (
            <div className="m-empty" data-testid="m-route-stops-empty">No stops on this route.</div>
          )}

          {route.stops?.map(s => (
            <div key={s.id} className="m-card" data-testid={`m-route-stop-${s.id}`}>
              <div className="m-card-title">
                {s.sort_order + 1}. {s.location_name || s.address1 || "Stop"}
              </div>
              <div className="m-card-sub">
                {[s.address1, s.city, s.state].filter(Boolean).join(", ") || "—"}
              </div>
              {s.job_number && (
                <div className="m-card-sub" style={{ marginTop: 4 }}>
                  Job #{s.job_number} · {s.attempt_count || 0} attempt{s.attempt_count === 1 ? "" : "s"}
                </div>
              )}
              {s.notes && <div className="m-card-sub">{s.notes}</div>}
              <div className="m-row" style={{ marginTop: 8 }}>
                {s.job_id && (
                  <>
                    <button
                      type="button"
                      className="m-btn"
                      onClick={() => navigate(`/m/jobs/${s.job_id}`)}
                      data-testid={`m-route-stop-open-${s.id}`}
                    >OPEN JOB</button>
                    <button
                      type="button"
                      className="m-btn m-btn-primary"
                      onClick={() => navigate(`/m/jobs/${s.job_id}/attempt/new`)}
                      data-testid={`m-route-stop-attempt-${s.id}`}
                    >+ ATTEMPT</button>
                  </>
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </MobileShell>
  );
}
